
import {error_event} from './analysis'

function version_to_array(version) {
  const result  = version.match(/\d+/g);
  return result.map(item=>{
    return parseInt(item);
  })
}

function _compare_version(a, b) {
  try {
    if (!a || !b) {
      return -1
    }
    const a_array =  version_to_array(a);
    const b_array = version_to_array(b);
    const a_length = a_array.length;
    const b_length = b_array.length;
    const max_length = a_length > b_length ? a_length : b_length;
    for (let i = 0; i < max_length; ++i) {
      const t1 = a_array[i] ? a_array[i] : 0;
      const t2 = b_array[i] ? b_array[i] : 0;
      if (t1 > t2) {
        return 1
      } else if (t1 < t2) {
        return -1
      }
    }
    return 0
  } catch (e) {
    // console.error(e.message)
    error_event(e,"_compare_version");
    return -1
  }
}


export  function compare_version(calc,version){
  if(!version){
    return false; //默认返回false
  }
  const current_version = window.$bus.device_info.appVersion;
  switch(calc){
    case '>':
      return _compare_version(current_version,version) > 0;
      break;
    case '>=':
      return _compare_version(current_version,version) >= 0;
      break;
    case '<':
      return _compare_version(current_version,version) < 0;
      break;
    case '<=':
      return _compare_version(current_version,version) <= 0;
      break;
    case '==':
    case '===':
      return _compare_version(current_version,version) === 0;
      break;
    default:
      return false;
  }
}



// WEBPACK FOOTER //
// ./src/tools/mgtv/version.js